export const getRandomElement = array => (array && Array.isArray(array)) ? array[Math.floor(Math.random() * array.length)] : 0;

export const searchTypes = {
  property: 'Property',
  room: 'Rooms',
};

export const searchTypeOptions = Object.keys(searchTypes).map(key => ({
  id: key,
  label: searchTypes[key],
}));

export const getFullHotelLocation = hotel => {
  let location = `${hotel.address} ${hotel.cityName}`;
  if (hotel.area && hotel.area !== 'NULL') {
    location += `, ${hotel.area}`;
  }
  if (hotel.state && hotel.state !== 'NULL') {
    location += `, ${hotel.state}`;
  }
  location += `, ${hotel.countryCode}`;
  return location;
};

export const getTaImage = rating => {
  const numRating = +rating.toString().replace(',', '.');
  const gap = (numRating * 10) % 5;
  let imageName;
  if (gap === 0) {
    imageName = numRating.toString().replace('.', '_');
  } else if (gap <= 2.5) {
    imageName = (((numRating * 10) - gap) / 10).toString().replace('.', '_');
  } else if (gap > 2.5) {
    imageName = (((numRating * 10) - gap + 5) / 10).toString().replace('.', '_');
  }
  return `https://carsolizeprod.blob.core.windows.net/images/TrustYou/${imageName}.png`;
};

const TOP_ROOM_AMENITIES = [
  'Air conditioning',
  'Hair dryer',
  'Iron/ironing board',
].map(item => item.toLowerCase());

export const transformRoomAmenities = amenities => {
  return amenities.filter(amenity => {
    return TOP_ROOM_AMENITIES.includes(amenity.toLowerCase());
  });
};

export const transformHotelData = hotel => ({
  raw: hotel,
  id: hotel.hotelId,
  title: hotel.displayName,
  stars: +hotel.starRating,
  price: +hotel.minPrice,
  mainImg: {
    src: `/data/converted/images/hotels/${hotel.hotelId}-main-320x192.jpg`,
    src2x: `/data/converted/images/hotels/${hotel.hotelId}-main-640x384.jpg`,
  },
  taImage: getTaImage(hotel.filters.ratingReviews),
  images: hotel.images.map((item, index) => ({
    ...item,
    imageUrl: `/data/converted/hotels-thumbnails/${hotel.hotelId}-${index}.jpg`,
    src: `/data/converted/images/hotels/${hotel.hotelId}-thumb-48-${index}.jpg`,
    src2x: `/data/converted/images/hotels/${hotel.hotelId}-thumb-96-${index}.jpg`,
  })),
  location: getFullHotelLocation(hotel),
  facilities: hotel.topFacilities,
  features: [],
});

export const languageOptions = [
  { id: 'en', title: 'English', img: '/icons/flags/en.png' },
  { id: 'ar', title: 'Arabic', img: '/icons/flags/ar.png' },
  { id: 'fr', title: 'French', img: '/icons/flags/fr.png' },
  { id: 'pt', title: 'Portuguese', img: '/icons/flags/pt.png' },
  { id: 'zh', title: 'Chinese', img: '/icons/flags/zh.png' },
  { id: 'it', title: 'Italian', img: '/icons/flags/it.png' },
];

export const isTouchDevice = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

  var mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch)) { // eslint-disable-line
    return true;
  }

  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
};

export const refundabilityLabels = {
  NRF: 'Non Refundable',
  RF: 'Refundable',
};
